module.exports = __webpack_public_path__ + "img/head-side-goggles.4d905b1d.svg";